import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Icons from "../../../../Assets/Icons";
import { getFileType } from "../../../../utils/fileHelpers";
import { openSecureFileUrl } from "../../../../utils/secureFilePreview";
import "./PatientDetails.css";

const AttachmentsSection = ({ initialAttachments = [], attachments: attachmentsProp = [] }) => {
  const { t } = useTranslation();
  const [attachments, setAttachments] = useState([]);
  const providedAttachments = initialAttachments.length ? initialAttachments : attachmentsProp;

  useEffect(() => {
    if (providedAttachments.length > 0) {
      setAttachments(providedAttachments.map((a) => ({ ...a, id: crypto.randomUUID(), type: getFileType(a) })));
    }
  }, [providedAttachments.length]);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const dropRef = useRef(null);

  const openPicker = () => fileInputRef.current?.click();

  const addFiles = (fileList) => {
    const files = Array.from(fileList).map((file) => ({
      id: crypto.randomUUID(),
      name: file.name,
      file,
      url: URL.createObjectURL(file),
      type: getFileType({ name: file.name, mimeType: file.type }),
    }));

    setAttachments((prev) => [...prev, ...files]);
  };

  const handleInputChange = (e) => {
    if (e.target.files?.length) addFiles(e.target.files);
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) addFiles(e.dataTransfer.files);
    dropRef.current?.classList.remove("drag-over");
  };

  const handleOpen = (file) => {
    if (file.type === "image") setPreviewImage(file.url);
    else openSecureFileUrl(file.url);
  };

  const removeFile = (id) => {
    setAttachments((prev) => {
      const file = prev.find((f) => f.id === id);
      if (file?.url) URL.revokeObjectURL(file.url);
      return prev.filter((f) => f.id !== id);
    });
  };

  useEffect(() => {
    return () => attachments.forEach((f) => f.url && URL.revokeObjectURL(f.url));
  }, [attachments]);

  return (
    <>
      <div className="whp-container attachments-section">
        <div className="title-hr2">
          <p>{t("attachments")}</p>
          <hr />
        </div>

        <div className="attachments-grid" ref={dropRef} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
          {/* <div className="attachment-item upload-tile" onClick={openPicker}> */}
            {/* <div className="attachment-pdf upload-card">
              <img src={Icons.PdfRedIcon} className="pdf-icon" alt="Upload" />
              <span className="attachment-name">{t("Add files")}</span>
              <small className="upload-hint">{t("Drag & drop or click to upload")}</small>
            </div> */}
          {/* </div> */}

          {/* <input ref={fileInputRef} type="file" multiple accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt" hidden onChange={handleInputChange} /> */}

          {attachments.map((file) => (
            <div key={file.id} className="attachment-item">
              <div className="attachment-pdf" style={{ position: "relative" }}>
                {/* <button
                  className="attachment-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFile(file.id);
                  }}
                >
                  <img src={Icons.cross} alt="Remove" />
                </button> */}

                <div className="attachment-preview" onClick={() => handleOpen(file)}>
                  {file.type !== "image" ? (
                    <img src={Icons.PdfRedIcon} className="pdf-icon-small" alt="PDF" />
                  ) : (
                    <img
                      src={file.url}
                      className="attachment-image-fit"
                      alt={file.name}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                        const fallback = e.currentTarget.parentElement?.querySelector(".attachment-preview-fallback");
                        if (fallback) fallback.style.display = "flex";
                      }}
                    />
                  )}
                  <div className="attachment-preview-fallback">Preview unavailable</div>
                </div>
                <span className="attachment-name">{file.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {previewImage && (
        <div className="image-preview-overlay" onClick={() => setPreviewImage(null)}>
          <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} className="image-preview" alt="Preview" />
            <button className="image-preview-close" onClick={() => setPreviewImage(null)}>
              <img src={Icons.cross} alt="Close" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AttachmentsSection;
